import React from 'react';
function NotFound() {
    return (
        <React.Fragment>
            <section className="error404">
                <h2 className="">Error 404 not found</h2>
                <p>
                    The URL you are trying to access does not exist.
                </p>
            </section>
        </React.Fragment>
    );
}
export default NotFound;